import React from 'react';
import { Link } from 'react-router-dom';
import ScreenshotGallery from './ScreenshotGallery';
import './LandingPage.css';

const LandingPage: React.FC = () => {
  return (
    <div className="landing-page">
      <header className="landing-header">
        <div className="container">
          <div className="header-content">
            <div className="header-left">
              <div className="logo">🍌 Todo Bananowe.it</div>
              <div className="tagline">Professional task management platform</div>
            </div>
            <div className="header-right">
              <div className="social-links">
                <a href="https://github.com/blazejkapala" target="_blank" rel="noopener noreferrer" className="social-link">
                  <svg viewBox="0 0 24 24" width="20" height="20" fill="currentColor">
                    <path d="M12 0C5.37 0 0 5.37 0 12c0 5.31 3.435 9.795 8.205 11.385.6.105.825-.255.825-.57 0-.285-.015-1.23-.015-2.235-3.015.555-3.795-.735-4.035-1.41-.135-.345-.72-1.41-1.23-1.695-.42-.225-1.02-.78-.015-.795.945-.015 1.62.87 1.845 1.23 1.08 1.815 2.805 1.305 3.495.99.105-.78.42-1.305.765-1.605-2.67-.3-5.46-1.335-5.46-5.925 0-1.305.465-2.385 1.23-3.225-.12-.3-.54-1.53.12-3.18 0 0 1.005-.315 3.3 1.23.96-.27 1.98-.405 3-.405s2.04.135 3 .405c2.295-1.56 3.3-1.23 3.3-1.23.66 1.65.24 2.88.12 3.18.765.84 1.23 1.905 1.23 3.225 0 4.605-2.805 5.625-5.475 5.925.435.375.81 1.095.81 2.22 0 1.605-.015 2.895-.015 3.3 0 .315.225.69.825.57A12.02 12.02 0 0024 12c0-6.63-5.37-12-12-12z"/>
                  </svg>
                </a>
                <a href="https://www.linkedin.com/in/blazejkapala/" target="_blank" rel="noopener noreferrer" className="social-link">
                  <svg viewBox="0 0 24 24" width="20" height="20" fill="currentColor">
                    <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
                  </svg>
                </a>
              </div>
            </div>
          </div>
        </div>
      </header>

      <section className="hero">
        <div className="container">
          <h1>Advanced Task Management Platform</h1>
          <p>A comprehensive TODO application with modern interface and powerful features. Advanced filtering, Kanban boards, multiple visual themes, and complete task lifecycle management for teams and individuals.</p>
          <div className="cta-buttons">
            <Link to="/app" className="btn btn-primary">🚀 Launch App</Link>
            <a href="#about" className="btn btn-secondary">📚 Learn More</a>
          </div>
        </div>
      </section>

      <section id="about" className="about">
        <div className="container">
          <h2>Why Todo Bananowe.it?</h2>
          <div className="about-content-simple">
            <div className="about-left-column">
              <p>
                Built with modern technologies and designed for productivity, 
                Todo Bananowe.it delivers a comprehensive approach to task management. 
                Whether you're organizing personal projects or coordinating with a team, 
                our platform provides enterprise-grade tools in an intuitive, elegant interface.
              </p>
              <div className="tech-stack">
                <h3>Built with</h3>
                <div className="tech-badges">
                  <span className="tech-badge">React</span>
                  <span className="tech-badge">TypeScript</span>
                  <span className="tech-badge">Go</span>
                  <span className="tech-badge">Docker</span>
                </div>
              </div>
            </div>
            <div className="about-right-column">
              <p>
                From simple task lists to complex project workflows with Kanban boards, advanced filtering, 
                and comprehensive analytics - everything is engineered to maximize your productivity and organizational efficiency.
              </p>
              <p>
                Experience seamless collaboration with team management, real-time updates, and powerful 
                import/export capabilities. The sleek dark theme ensures comfortable viewing during 
                extended work sessions while maintaining professional aesthetics for business environments.
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className="screenshots">
        <div className="container">
          <h2>See Todo Bananowe.it in Action</h2>
          <ScreenshotGallery />
        </div>
      </section>

      <footer className="landing-footer">
        <div className="container">
          <p>&copy; 2024 Todo Bananowe.it - Professional task management 🍌</p>
          <p>Built with ❤️ using React, Go and lots of coffee ☕</p>
        </div>
      </footer>
    </div>
  );
};

export default LandingPage; 